import { theme as antdTheme } from 'antd';

const palette = {
  page: '#F4F4F0',
  surface: '#FFFFFF',
  text: '#1A1A1A',
  textMuted: '#6B6B6B',
  border: '#D4D4D4',
  green: '#5A6F56',
  greenDark: '#4A5F46',
};

const fontFamily = "'IBM Plex Mono', ui-monospace, 'SFMono-Regular', Menlo, monospace";

/** Светлая тема Ant Design — только экран входа сотрудников */
export const staffAntdTheme = {
  algorithm: antdTheme.defaultAlgorithm,
  token: {
    colorPrimary: palette.green,
    colorInfo: palette.green,
    colorSuccess: palette.green,
    colorLink: palette.greenDark,
    colorLinkHover: palette.green,

    colorBgBase: palette.page,
    colorBgLayout: palette.page,
    colorBgContainer: palette.surface,

    colorBorder: palette.border,
    colorBorderSecondary: palette.border,

    colorText: palette.text,
    colorTextSecondary: palette.textMuted,
    colorTextTertiary: palette.textMuted,
    colorTextPlaceholder: palette.textMuted,

    fontFamily,
    fontSize: 16,
    borderRadius: 6,
    borderRadiusLG: 6,
    borderRadiusSM: 6,
    wireframe: false,
  },
  components: {
    Button: {
      colorPrimary: palette.green,
      colorPrimaryHover: palette.greenDark,
      defaultBg: palette.surface,
      defaultColor: palette.green,
      defaultBorderColor: palette.green,
      borderRadius: 6,
      controlHeight: 46,
      fontWeight: 400,
    },
    Input: {
      colorBgContainer: 'transparent',
      activeBorderColor: palette.green,
      hoverBorderColor: palette.green,
      colorText: palette.text,
    },
  },
};

export default staffAntdTheme;
